export default __webpack_public_path__ + "static/old-new-game-failure-icon-03601a9a751bf804d623a74dbf06d442.svg";